var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showPreloader } from "../../components/preloader";
import SearchResultKeys from "../../components/search_result_keys";
import useSimilarApi from "./api/similarApi";
import { addLiveEventListener, startIconLoading, stopIconLoading } from "../../utils";
import $ from '../../vendor/dom7';
import { StatusClassNames } from "../../types/StatusClassNames";
import EventBus from "../../events/EventBus";
let timerId;
let searchRequest;
export default function initSimilarProducts() {
    const element = document.getElementById('similar-products');
    const searchInput = document.getElementById('similar-search');
    const searchResults = document.getElementById('similar-search-result');
    if (!element || !searchInput || !searchResults) {
        return;
    }
    const productId = parseInt(element.dataset.productId);
    const api = useSimilarApi(productId);
    new SearchResultKeys(searchInput, searchResults, '.search-result__item', onSelect);
    addLiveEventListener(element, 'click', ['.similar-vote--up', '.similar-vote--down'], function () {
        return __awaiter(this, void 0, void 0, function* () {
            const wrap = $(this).parents('.prod-teaser');
            const vote = this.matches('.similar-vote--up') ? 'upvote' : 'downvote';
            startIconLoading(this);
            const data = yield api.vote(vote, parseInt(wrap.data('id')));
            if (data.upvotes !== undefined) {
                wrap.find('.prod-teas__vote-item--up .stats-item__label').text(data.upvotes.toString());
            }
            if (data.downvotes !== undefined) {
                wrap.find('.prod-teas__vote-item--down .stats-item__label').text(data.downvotes.toString());
            }
            wrap.find('.is-pressed').removeClass(StatusClassNames.pressed);
            if (data.active) {
                wrap.find(data.active === 'upvote' ? '.similar-vote--up' : '.similar-vote--down').addClass(StatusClassNames.pressed);
            }
            stopIconLoading(this);
        });
    });
    addLiveEventListener(element, 'click', '.similar-vote--delete', function () {
        return __awaiter(this, void 0, void 0, function* () {
            showPreloader();
            yield api.delete(parseInt($(this).parents('.prod-teaser').data('id')));
            document.location.reload();
        });
    });
    // search
    searchInput.addEventListener('input', function () {
        let txt = searchInput.value.trim();
        let lastQuery = searchInput.dataset.lastQuery;
        clearTimeout(timerId);
        if (searchRequest) {
            searchRequest.abort();
        }
        if (txt.length < 2) {
            searchInput.dataset.lastQuery = '';
        }
        else {
            if (txt === lastQuery) {
                return;
            }
            timerId = setTimeout(function () {
                return __awaiter(this, void 0, void 0, function* () {
                    searchInput.dataset.lastQuery = txt;
                    const data = yield api.search(txt);
                    searchResults.innerHTML = data.html;
                    EventBus.emit('products:load');
                    searchRequest = null;
                    searchResults.show();
                    searchInput.focus();
                });
            }, 400);
        }
    });
    searchInput.addEventListener('blur', () => setTimeout(() => searchInput.matches(':not(:focus)') && searchResults.close(), 200));
    searchInput.addEventListener('focus', () => {
        if (searchInput.value.trim().length >= 2) {
            searchResults.show();
            searchInput.focus();
        }
    });
    addLiveEventListener(searchResults, 'click', 'a', function (e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            onSelect(this);
        });
    });
    function onSelect(el) {
        return __awaiter(this, void 0, void 0, function* () {
            el = el === null || el === void 0 ? void 0 : el.closest('.search-result__item');
            if (!el) {
                return;
            }
            showPreloader();
            yield api.add(parseInt(el.dataset.id));
            document.location.reload();
        });
    }
    if (element.querySelector('.prod-teaser')) {
        setTimeout(function () {
            return __awaiter(this, void 0, void 0, function* () {
                const data = yield api.getActive();
                for (const index in data.active) {
                    const el = element.querySelector(`[data-id="${index}"] .similar-vote--${data.active[index] === 'upvote' ? 'up' : 'down'}`);
                    if (el) {
                        el.classList.add(StatusClassNames.pressed);
                    }
                }
            });
        }, 1000);
    }
}
